import styled from 'styled-components';

export const FilterContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  align-items: flex-end;
`;

export const FilterWrapper = styled.div`
  min-width: 200px;
  flex: 1;
  max-width: 300px;
`;

export const FilterGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

